export { onBeforeRenderClient };
const onBeforeRenderClient = (pageContext) => {
    hydratePinia(pageContext);
};
function hydratePinia(pageContext) {
    if (!pageContext.isHydration) {
        return;
    }
    const { pinia } = pageContext;
    const piniaInitialState = pageContext._piniaInitialState;
    if (!pinia || !piniaInitialState) {
        // happens if SSR is off
        return;
    }
    pinia.state.value = piniaInitialState;
}
